var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "vector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 47 17 L 47 23 C 47 23.53 47.211 24.039 47.586 24.414 C 47.961 24.789 48.47 25 49 25 L 55 25 L 47 17 L 41 17 L 41 46 C 41 46.53 40.789 47.039 40.414 47.414 C 40.039 47.789 39.53 48 39 48 L 11 48 C 10.47 48 9.961 47.789 9.586 47.414 C 9.211 47.039 9 46.53 9 46 L 9 7 C 9 6.47 9.211 5.961 9.586 5.586 C 9.961 5.211 10.47 5 11 5 L 33 5 L 41 13 L 35 13 C 34.47 13 33.961 12.789 33.586 12.414 C 33.211 12.039 33 11.53 33 11 L 33 5",
    fill: "#00000000",
    stroke: "#69359b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 55 29 L 55 57 C 55 57.53 54.789 58.039 54.414 58.414 C 54.039 58.789 53.53 59 53 59 L 25 59 C 24.47 59 23.961 58.789 23.586 58.414 C 23.211 58.039 23 57.53 23 57 L 23 48",
    fill: "#00000000",
    stroke: "#69359b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReports);
export default __webpack_public_path__ + "static/media/ic_reports.f0d557328cf65673e062e3003744dd10.svg";
export { ForwardRef as ReactComponent };